module.exports = "<svg>\n    <use xlink:href=\"{{::iconHref}}\"></use>\n</svg>\n<label class=\"cui-icon__label\" ng-transclude></label>\n";